import React from 'react';
import propTypes from 'prop-types';
import { concatClassName } from '@dateam/ark-react';
import styles from './SidePanelList.module.scss';

type Props = {
    children?: React.ReactNode;
    className?: string;
};

const SidePanelList: React.FC<Props> = ({ children, className }: Props) => (
    <div className={concatClassName(className, styles['list'])}>
        {children}
    </div>
);

SidePanelList.propTypes = {
    children: propTypes.node,
    className: propTypes.string
};

SidePanelList.defaultProps = {
    children: undefined,
    className: undefined
};

export default SidePanelList;
